import { render } from "./PrivatePolicy.vue?vue&type=template&id=bb43088e&scoped=true"
const script = {}

import "./PrivatePolicy.vue?vue&type=style&index=0&id=bb43088e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb43088e"]])

export default __exports__